import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { fetchLanguages } from 'src/store/lists/languages/asyncThunk';
import { checkIsLoading } from 'src/utils/types/statuses';
import {
  checkCanLoadLanguages,
  getLanguagesForSelect,
} from 'src/store/lists/languages/helpers';

import { BaseMultiSelect } from '../../../common';

type PLanguagesMultiSelect = any;

export const LanguagesMultiSelect: React.FC<PLanguagesMultiSelect> = (
  props,
) => {
  const { label = 'Language', placeholder, ...otherProps } = props;

  const dispatch = useDispatch();
  useEffect(() => {
    checkCanLoadLanguages(() => dispatch(fetchLanguages()));
  }, [dispatch]);

  const { status: languagesStatus } = useSelector(
    (state: RootState) => state.languages,
  );
  const languagesOptions = useSelector(getLanguagesForSelect);

  return (
    <BaseMultiSelect
      options={languagesOptions}
      label={label}
      placeholder={placeholder}
      loading={checkIsLoading(languagesStatus)}
      {...otherProps}
    />
  );
};
